// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5573":"css/admin-app.6728","7349":"css/app.6728"}[chunkId] + ".css";
};